import { render, staticRenderFns } from "./VuePhenomenon.vue?vue&type=template&id=ec6c8d8c&"
import script from "./VuePhenomenon.vue?vue&type=script&lang=js&"
export * from "./VuePhenomenon.vue?vue&type=script&lang=js&"
import style0 from "./VuePhenomenon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../.nvm/versions/node/v10.19.0/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports